import { useResolve } from '@/infrastructure/useResolve';
import { type Messages } from '@/i18n/messages';
import { TOKEN_LocaleStore } from './LocaleStore';

export function useT(): Messages {
  return useResolve(TOKEN_LocaleStore).messages;
}
